import { Path, Svg } from '@react-pdf/renderer'

import { styles } from '../styles/styles'

/**
 * HiveWatch icon+text logo (black), from the Figma Foundation library
 * (file SkuYW7JEVMSUxnNC4lpTi4, node 929-244). Inlined as react-pdf vector
 * paths rather than a PNG so it stays crisp at any zoom in the exported PDF.
 */
export const HiveWatchLogo = () => (
  <Svg style={styles.footerBrandingLogo} viewBox='0 0 160 28.9465'>
    <Path
      d='M94.0964 7.32797L96.8993 7.32797L99.1854 16.6512L101.471 7.32797H104.831L101.034 21.6011H97.8137L95.4481 12.4766L93.1024 21.6011H89.9019L86.0851 7.32797L89.5242 7.32797L91.8302 16.6512L94.0964 7.32797Z'
      fill='#000000'
    />
    <Path
      d='M3.91632 19.4332L3.91632 9.51197L12.4634 4.55001L21.0079 9.50931V19.4319L12.4634 24.3952L3.91632 19.4332ZM12.4634 0L0 7.23829L0 21.7082L12.4634 28.9465L24.9269 21.7082L23.0862 20.6412V8.30669L12.4634 2.13813V0Z'
      fill='#000000'
    />
    <Path
      d='M12.4635 7.97051V5.83238L5.02128 10.1512L5.02128 18.7914L12.4635 23.1102L19.903 18.7914L18.0624 17.7217L18.0624 11.2182L12.4635 7.96785V7.97051ZM15.9854 16.5177L12.4622 18.5628L8.93892 16.5177L8.93892 12.4262L12.4622 10.3797L15.9854 12.4262V16.5177Z'
      fill='#000000'
    />
    <Path
      d='M12.4635 11.6648L10.0451 13.0694L10.0451 15.8786L12.4635 17.2805L14.8818 15.8786L12.4635 14.4726V11.6648Z'
      fill='#000000'
    />
    <Path
      d='M130.807 10.1707H126.434V21.6011H123.114V10.1707H118.741V7.32797L130.807 7.32797V10.1707Z'
      fill='#000000'
    />
    <Path
      d='M73.1758 7.32797L83.2545 7.32797V10.1707L76.436 10.1707V12.914L82.1214 12.914V15.7169L76.436 15.7169V18.7584H83.2545V21.6011H73.1758V7.32797Z'
      fill='#000000'
    />
    <Path
      d='M65.2884 21.6011H61.8493L56.6212 7.32797L60.1795 7.32797L63.6186 17.3271L67.0775 7.32797L70.4967 7.32797L65.2884 21.6011Z'
      fill='#000000'
    />
    <Path
      d='M53.6082 7.12988V21.403H50.2884V7.12988L53.6082 7.12988Z'
      fill='#000000'
    />
    <Path
      d='M42.7935 7.12988H46.1133V21.403H42.7935V15.5188L36.9888 15.5188V21.403H33.669L33.669 7.12988L36.9888 7.12988V12.696L42.7935 12.696V7.12988Z'
      fill='#000000'
    />
    <Path
      d='M156.68 7.33229L160 9.23421V21.6054H156.68V15.7212L150.876 15.7212V21.6054H147.556V7.33229L150.876 7.33229V12.8984L156.68 12.8984V7.33229Z'
      fill='#000000'
    />
    <Path
      d='M135.218 14.4688C135.218 17.1922 136.629 18.9416 138.617 18.9416C140.088 18.9416 141.141 18.0073 141.479 16.4965L144.6 17.5302C143.726 20.1343 141.698 21.824 138.637 21.824C134.721 21.824 131.898 18.7826 131.898 14.4688C131.898 10.1551 134.721 7.11356 138.637 7.11356C141.698 7.11356 143.726 8.80328 144.6 11.4074L141.479 12.4411C141.141 10.9303 140.088 9.99602 138.617 9.99602C136.629 9.99602 135.218 11.7454 135.218 14.4688Z'
      fill='#000000'
    />
    <Path
      d='M110.262 7.32165L113.701 7.32165L118.929 21.5948L115.371 21.5948L111.932 11.5956L108.473 21.5948L105.054 21.5948L110.262 7.32165Z'
      fill='#000000'
    />
  </Svg>
)
